import React from "react";
import { useState } from "react";
import { useReducer } from "react";
import { useMemo } from "react";
import stringToNumArray from "../../../../../../utils/stringManipulation/StringToNumArray";

export const useScalingInEnabled = (tactic) => {
  const [scalingInEnabled, setScalingInEnabled] = useState(
    tactic !== undefined
  );
  return [scalingInEnabled, setScalingInEnabled];
};
export const useAddToWinnerEnabled = (tactic) => {
  const [addToWinnerEnabled, setAddToWinnerEnabled] = useState(
    tactic !== undefined
  );
  return [addToWinnerEnabled, setAddToWinnerEnabled];
};

export const useScalingIn = (breakPrices, quantityBasisValues) => {
  const [scalingIn, dispatchScalingIn] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      quantityBasisValues: breakPrices !== undefined ? breakPrices : [],
      breakPrices: quantityBasisValues !== undefined ? quantityBasisValues : [],
    }
  );
  return [scalingIn, dispatchScalingIn];
};

export const useAddToWinner = (breakPrices, quantityBasisValues) => {
  const [addToWinner, dispatchAddToWinner] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      quantityBasisValues: breakPrices !== undefined ? breakPrices : [],
      breakPrices: quantityBasisValues !== undefined ? quantityBasisValues : [],
    }
  );
  return [addToWinner, dispatchAddToWinner];
};

export function usePositionTactics(
  scaleInEnabled,
  addToWEnabled,
  scaleIn,
  addToW
  //positionsTacticsProcessor
) {
  const [scalingInEnabled, setScalingInEnabled] = scaleInEnabled;
  const [addToWinnerEnabled, setAddToWinnerEnabled] = addToWEnabled;
  const [scalingIn, dispatchScalingIn] = scaleIn;
  const [addToWinner, dispatchAddToWinner] = addToW;
  //const positionTacticsProcessor = positionsTacticsProcessor;

  const positionTacticsProcessor = useMemo(
    () => ({
      scalingIn: {
        quantityBasisValues: stringToNumArray(scalingIn.quantityBasisValues),
        breakPrices: stringToNumArray(scalingIn.breakPrices),
      },
      addToWinner: {
        quantityBasisValues: stringToNumArray(addToWinner.quantityBasisValues),
        breakPrices: stringToNumArray(addToWinner.breakPrices),
      },
    }),
    [scalingIn, addToWinner]
  );

  const positionTactics = useMemo(
    () => ({
      ...(scalingInEnabled && {
        SCALING_IN: positionTacticsProcessor.scalingIn,
      }),
      ...(addToWinnerEnabled && {
        ADD_TO_WINNER: positionTacticsProcessor.addToWinner,
      }),
    }),
    [positionTacticsProcessor, scalingInEnabled, addToWinnerEnabled]
  );
  return positionTactics;
}
